import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useBoxesList() {
    const toast = useToast()
    const records = ref(null)

    // Table Handler
    const columns = [
        { key: 'number', label: 'Box number', sortable: true },
        { key: 'type', label: 'Box Type', sortable: true },
        { key: 'received', label: 'Received', sortable: true },
        { key: 'ranges', label: 'Ranges', },
        'actions',
    ]

    const from = ref(0)
    const to = ref(0)
    const meta = ref({ from: 0, to: 0, total: 0 })
    const perPage = ref(10)
    const totalRecords = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [5, 10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('number')
    const isSortDirDesc = ref(false)
    const locationFilter = ref(null)
    const locationType = ref(null)

    const refetch = () => {
        records.value.refresh()
    }

    watch([locationFilter, currentPage, perPage, searchQuery, sortBy, isSortDirDesc], () => {
        refetch()
    })

    const fetch = (ctx, callback) => {
        store
            .dispatch('cromis-box/list', {
            location_id: locationFilter.value,
            query: searchQuery.value,
            per_page: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
        })
        .then(response => {
            const { boxes, meta } = response.data

            meta.value = meta

            callback(boxes)
            totalRecords.value = meta.value.total
            from.value = meta.value.from
            to.value = meta.value.to
        })
        .catch((error) => {
            toast({
                component: ToastificationContent,
                props: {
                    title: 'Error fetching boxes list',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                },
            })
        })
    }

    // *===============================================---*
    // *--------- UI ---------------------------------------*
    // *===============================================---*

    const resolveGrowerTypeVariant = society => {
        if (society !== null) return 'success'
        return 'primary'
    }

    const resolveStatusVariant = type => {
        if (type === 1) return 'success'
        if (type === 2) return 'secondary'
        return 'warning'
    }


    const resolveReceivedVariant = received => {
        if (received == true) return 'success'
        if (received == false) return 'secondary'
        return 'warning'
    }

    return {
        fetch,
        columns,
        perPage,
        currentPage,
        totalRecords,
        from,
        to,
        meta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        records,
    
        // resolveUserRoleVariant,
        // resolveUserRoleIcon,
        resolveGrowerTypeVariant,
        resolveStatusVariant,
        refetch,
        resolveReceivedVariant,
        // Extra Filters
        // roleFilter,
        // planFilter,
        // statusFilter,
        locationFilter,
    }
}
